import { Box, Button, Grid, SwipeableDrawer, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect } from "react";
import AnalyticsService from "../../Services/AnalyticsService";
import AndroidService from "../../Services/AndroidService";
import StringUtils from "../../Utils/StringUtils";

const VanDetailsDialog = ({ open, handleClose, vanDetails }) => {
  useEffect(() => {
    if (open) {
      AnalyticsService.pushEvent("Drawer Opened", {
        type: "VAN Details",
        lendingProvider: vanDetails?.lendingProvider,
      });
      AndroidService.unsetPullToRefresh();
    } else {
      AndroidService.setPullToRefresh();
    }
  }, [open]);

  return (
    <>
      <SwipeableDrawer
        anchor={`bottom`}
        onOpen={() => {}}
        open={open}
        disableDiscovery={true}
        disableSwipeToOpen={true}
        onClose={() => {
          handleClose();
        }}
        sx={{
          "& .MuiDrawer-paper": {
            borderTopLeftRadius: 30,
            borderTopRightRadius: 30,
          },
          zIndex: 1100,
        }}
      >
        <Grid container alignItems={"center"} mt={2} mb={1}>
          <Grid item xs={4}></Grid>
          <Grid
            item
            xs={4}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Box
              sx={{
                width: 50,
                height: 6,
                position: "absolute",
                borderRadius: 3,
                backgroundColor: "#ddd",
              }}
            />
          </Grid>
          <Grid item xs={4} textAlign={"end"}>
            <CloseIcon
              onClick={handleClose}
              sx={{
                color: "#CACACA",
                fontSize: "28px",
                cursor: "pointer",
                mr: 2,
              }}
            />
          </Grid>
        </Grid>

        <Typography fontWeight={700} margin={"0px 24px 8px 24px"}>
          {StringUtils.convertToTitleCase(vanDetails?.lendingProvider)} VAN
          Account Details
        </Typography>
        <Box
          sx={{
            m: 2,
            mt: 0,
            borderRadius: 4,
            p: 2,
            pb: 1,
            backgroundColor: vanDetails?.backgroundColor,
          }}
        >
          <Box display={"flex"} justifyContent={"end"} mb={1}>
            <img
              src={vanDetails?.iconPath}
              height={25}
              alt={StringUtils.convertToTitleCase(vanDetails?.lendingProvider)}
            />
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              gap: "4px",
              mb: 1,
            }}
          >
            <Typography sx={{ fontSize: "14px" }}>Account Number:</Typography>
            <Typography sx={{ fontSize: "14px", textAlign: "end" }}>
              {vanDetails?.accountNumber}
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              gap: "4px",
              mb: 1,
            }}
          >
            <Typography sx={{ fontSize: "14px" }}>Account Name:</Typography>
            <Typography sx={{ fontSize: "14px", textAlign: "end" }}>
              {vanDetails?.accountName}
            </Typography>
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              gap: "4px",
              mb: 1,
            }}
          >
            <Typography sx={{ fontSize: "14px" }}>IFSC Code:</Typography>
            <Typography sx={{ fontSize: "14px", textAlign: "end" }}>
              {vanDetails?.ifscCode}
            </Typography>
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              gap: "4px",
              mb: 1,
            }}
          >
            <Typography sx={{ fontSize: "14px" }}>Branch:</Typography>
            <Typography sx={{ fontSize: "14px", textAlign: "end" }}>
              {vanDetails?.branchName}
            </Typography>
          </Box>
        </Box>

        <Button
          fullWidth
          variant="contained"
          sx={{
            borderRadius: 0,
            fontWeight: 700,
            padding: 1.5,
            fontSize: "12px",
          }}
          onClick={handleClose}
        >
          Close
        </Button>
      </SwipeableDrawer>
    </>
  );
};
export default VanDetailsDialog;
